export type { TabSlots, TabValue, TabProps, TabState } from './Tab.types';
export { Tab } from './Tab';
export { renderTab } from './renderTab';
export { useTab } from './useTab';
